<template>
  <div :class="{'container-dark': theme_dark}">
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">提现</div>
      <div class="nav-right">
        <span class="nav-lable"></span>
        <img src="../../assets/img/返回箭头.png" class="nav-img none" />
      </div>
    </div>

    <div class="top ub">
      <div class="ub ub-ver">
        <span class="score">{{ score_tx }}</span>
        <span class="txt">可提现积分</span>
      </div>
      <div class="ub ub-ver" style="margin-left: 1.5em">
        <span class="frost" @click="goto_gift_gouSu2()">{{ score_frost }}</span>
        <div class="ub ub-pc" @click="goto_gift_gouSu2()">
          <span class="txt">冻结积分?</span>
          <img src="../../assets/img/new/常见问题.png" class="wt-img none" />
        </div>
      </div>
    </div>

    <ul class="tx-block">
      <!-- 积分兑换金币 -->
      <li class="tx ub ub-ac2">
        <div class="tx-item-coin ub ub-ver" @click="barter_coin(300, 1000)">
          <div class="ub ub-pc ub-ac">
            <img src="../../assets/img/一堆金币.png" />
          </div>
          <span class="sp1 ub ub-ac">300金币</span>
          <span class="sp2">1000积分</span>
        </div>
        <div class="tx-item-coin ub ub-ver" @click="barter_coin(4500, 10000)">
          <div class="ub ub-pc ub-ac">
            <img src="../../assets/img/一堆金币2.png" />
          </div>
          <span class="sp1 ub ub-ac">4500金币</span>
          <span class="sp2">10,000积分</span>
        </div>
      </li>

      <!-- 积分兑换会员 -->
      <li class="tx ub ub-ac2">
        <div class="tx-item-vip ub ub-ver" @click="barter_vip(1, 8800)">
          <div class="ub ub-pc ub-ac">
            <img src="../../assets/img/会员.png" />
          </div>
          <span class="sp1 ub ub-ac">1天会员</span>
          <span class="sp2">8800积分</span>
        </div>
        <div class="tx-item-vip ub ub-ver" @click="barter_vip(7, 29900)">
          <div class="ub ub-pc ub-ac">
            <img src="../../assets/img/会员.png" />
          </div>
          <span class="sp1 ub ub-ac">7天会员</span>
          <span class="sp2">29,900积分</span>
        </div>
      </li>

      <!-- 积分兑换红包 -->
      <li class="tx ub ub-ac2">
        <div class="tx-item ub ub-ver" :class="mny_one > 0 ? 'no' : ''" @click="Tx_Info_mny(1)">
          <div class="ub ub-pc ub-ac">1<span>元</span></div>
          <span class="score2">1000积分</span>
          <span class="dtl">首次提现专享</span>
        </div>
        <div class="tx-item ub ub-ver" @click="Tx_Info_mny(10)">
          <div class="ub ub-pc ub-ac">10<span>元</span></div>
          <span class="score2">10000积分</span>
          <span class="dtl">每日限一次</span>
        </div>
      </li>

      <li class="tx ub ub-ac2">
        <div class="tx-item ub ub-ver" @click="Tx_Info_mny(50)">
          <div class="ub ub-pc ub-ac">50<span>元</span></div>
          <span class="score2">50,000积分</span>
          <span class="dtl">手续费减免10%</span>
        </div>
        <div class="tx-item ub ub-ver" @click="Tx_Info_mny(100)">
          <div class="ub ub-pc ub-ac">100<span>元</span></div>
          <span class="score2">100,000积分</span>
          <span class="dtl">手续费减免20%</span>
        </div>
      </li>

      <li class="tx ub ub-ac2">
        <div class="tx-item ub ub-ver" @click="Tx_Info_mny(300)">
          <div class="ub ub-pc ub-ac">300<span>元</span></div>
          <span class="score2">300,000积分</span>
          <span class="dtl">手续费减免30%</span>
        </div>
        <div class="tx-item ub ub-ver" @click="Tx_Info_mny(600)">
          <div class="ub ub-pc ub-ac">600<span>元</span></div>
          <span class="score2">600,000积分</span>
          <span class="dtl">手续费减免50%</span>
        </div>
      </li>

      <li class="tx ub ub-ac2">
        <div class="tx-item ub ub-ver" @click="Tx_Info_mny(1000)">
          <div class="ub ub-pc ub-ac">1000<span>元</span></div>
          <span class="score2">1,000,000积分</span>
          <span class="dtl">手续费减免60%</span>
        </div>
        <div class="tx-item ub ub-ver" @click="Tx_Info_mny(2000)">
          <div class="ub ub-pc ub-ac">2000<span>元</span></div>
          <span class="score2">2,000,000积分</span>
          <span class="dtl">手续费减免60%</span>
        </div>
      </li>

      <li class="tx ub ub-ac2">
        <div class="tx-item ub ub-ver" @click="Tx_Info_mny(3000)">
          <div class="ub ub-pc ub-ac">3000<span>元</span></div>
          <span class="score2">3,000,000积分</span>
          <span class="dtl">手续费减免60%</span>
        </div>
        <div class="tx-item ub ub-ver" @click="Tx_Info_mny(5000)">
          <div class="ub ub-pc ub-ac">5000<span>元</span></div>
          <span class="score2">5,000,000积分</span>
          <span class="dtl">手续费减免60%</span>
        </div>
      </li>
    </ul>

    <div class="tip-txt">
      <div class="prompt-block ub ub-ver ub-ac2">
        <span class="prompt-txt">提现申请后1~3个工作日之内会进行受理(平台会扣除相应的提现手续费，当前手续费为提现金额的20%)，请关注【小火柴新版】公众号。</span>
        <span class="prompt-txt">节假日的提现申请将会顺延到首个工作日进行受理。</span>
        <span class="prompt-txt">客服微信号: <label style="color: #e92162">xhczjj201712</label>,添加客服时请备注 “提现”。</span>
        <span class="prompt-txt">为了减少客服的工作量，每日限提1次，减免的手续费以积分的形式返还到账户下<label style="font-weight: 600;">（我的→我的钱包→挣钱明细）</label>，返还的积分可再次提现</span>
      </div>
    </div>

    <dlg ref="myConfirm_txAft"></dlg>
    <tx ref="TxInfo" @formBehavior="formact_tx"></tx>
    <dlg ref="myConfirm_gotoRenZhen" @formBehavior="formact_gotoRenZhen"></dlg>
    <alert ref="formshow_tx_coin" @userBehavior="formact_collect_data"></alert>
    <alert ref="formshow_tx_vip" @userBehavior="formact_collect_vip"></alert>
    <dlg ref="myForm_2"></dlg>
  </div>
</template>

<script>
import Alert from "../../components/Alert.vue";
import * as tool from "../../api/common";
import { mapMutations, mapActions } from "vuex";
import Tx from "../../components/Tx_Info.vue";
import Form from "../../components/Form.vue";
export default {
  components: {
    alert: Alert,
    tx: Tx,
    dlg: Form,
  },

  data() {
    return {
      score_tx: 0,
      score_frost: 0,
      mny_one: 0,
      mny_ten: 0,
      is_kill:100,
      theme_dark: false,
      click_tag: false
    };
  },
  mounted() {
    //切换深色模式
    this.theme_dark = tool.is_theme_dark(this);
    this.init_page();
  },
  methods: {
    ...mapMutations(["get", "post"]), //引入方法
    ...mapActions(["act_get_userinfo", "act_reload_userinfo"]), //引入方法
    back() {
      this.$router.go(-1); //返回上一层
    },
    goto_gift_gouSu2() {
      this.$router.push({ name: "gift_gouSu2" });
    },
    init_page() {
      //加载业务数据
      var self = this;
      var uid = self.$store.state.uid;

      self.get({
        url: "/App/GetUser_ScoreNot/?uid=" + uid,
        success: function (data) {
          //console.log(JSON.stringify(data));
          self.score_frost = data;

          self.act_get_userinfo({
            uid: uid,
            success: function (u) {
              //console.log(JSON.stringify(u));
              self.is_kill=u.is_kill;
              self.score_tx = u.score_left - self.score_frost;
              if (self.score_tx < 0) {
                self.score_tx = 0;
              }
              //检查是否完成认证
              var wx_check = u.wx_check;
              var tel = u.tel;

              if (!wx_check || !tel) {
                self.formshow_gotoRenZhen();
              }
            },
          });
        },
      });

      self.get({
        url: "/App/GetTxNumber/?uid=" + uid,
        success: function (data) {
          //console.log(JSON.stringify(data));
          self.mny_one = data.mny_one;
          self.mny_ten = data.mny_ten;
        },
      });
    },
    formshow_gotoRenZhen() {
      if (!this.$cookies.isKey("cookie_tx_rz")) {
        var ctxt = "";
        ctxt += '<div style="font-size: 0.9em;line-height: 1.6rem;color: #888;">';
        ctxt +="您还未完成认证，这可能会影响到您的提现审核速度，请先完成认证。位置:【我的】->【认证中心】";
        ctxt += "</div>";
        this.$refs.myConfirm_gotoRenZhen.show(ctxt, {
          type: "confirm",
          confirmText: "去认证",
          titleText: "认证提醒",
          data: "",
        });
        this.$cookies.set("cookie_tx_rz", 1, 60 * 60);
      }
    },
    formact_gotoRenZhen(type, data) {
      if (type == "clickConfirm") {
        this.$router.push({ name: "rz" });
      }
    },

    formact_tx(type, data) {
      if (type == "clickConfirm") {
        //处理连续点击问题
        if (this.click_tag) return;
        this.click_tag = true;

        var self = this;
        setTimeout(() => {
          self.click_tag = false;
        }, 5000);

        var uid = self.$store.state.uid;
        self.act_reload_userinfo({
          uid: uid,
          success: function (info) {
            self.init_page();
            self.formshow_txAft();
          },
        });
      }
    },

    formshow_txAft() {
      var ctxt = "";
      ctxt += '<div style="font-size: 1em;line-height: 1.8em;color: #666;">';
      ctxt +="您的提现申请已提交,平台正在加紧为你处理,请耐心等待哈。<br/>也可尝试添加客服微信【xhczjj201712】催促一下她，添加时请备注“提现”。";
      ctxt += "</div>";
      this.$refs.myConfirm_txAft.show(ctxt, {
        type: "alert",
        confirmText: "好的",
        titleText: "温馨提示",
        data: "",
      });
    },

    Tx_Info_mny(mny) {
      // var skipWxCheck = this.$store.state.skipWxCheck;
      // if (!skipWxCheck) {
      //   //检测是否关注公众号
      //   var wxInfo = this.$store.state.wxInfo;
      //   if(wxInfo == ""){
      //     this.show_sys_GuanzhuWx();
      //     return false;
      //   }
      // }
       
       if(this.is_kill!=0){
         this.$toast.center("该账号已被封禁，无法使用积分兑换功能");
          return false;
      }
      if (this.score_tx >= mny * 1000) {
        if (mny == 1 && this.mny_one > 0) {
          this.$toast.center("此为首次提现专享~");
          return false;
        }
        if (this.mny_ten > 0) {
          this.$toast.center("今日已提现过，每日限提一次~");
          return false;
        }

        this.$refs.TxInfo.show(mny, {
          type: "confirm",
          confirmText: "立即提现",
          titleText: "提现",
          data: "",
        });
      } else {
        this.$toast.center("你的可提现积分不足以兑换" + mny + "元");
      }
    },

    barter_coin(coin, score) {
      if(this.is_kill!=0){
         this.$toast.center("该账号已被封禁，无法使用积分兑换功能");
          return false;
      }
      if (score == 1000 && this.score_tx < score) {
        this.$toast.center("你的可用积分不足以兑换300金币");
        return false;
      }
      if (score == 10000 && this.score_tx < score) {
        this.$toast.center("你的可用积分不足以兑换4500金币");
        return false;
      }

      var ctxt ="兑换" +coin +"金币，需要消耗" +score +"积分，点击下方兑换按钮则可兑换成功，无需客服审核，立马获得金币";

      this.$refs.formshow_tx_coin.show(ctxt, {
        type: "confirm",
        confirmText: "立即兑换",
        titleText: "兑换金币",
        data: { coin: coin, score: score },
      });
    },

    formact_collect_data(type, data) {
      //console.log(JSON.stringify(data));
      if (type == "clickConfirm") {
        //处理连续点击问题
        if (this.click_tag) return;
        this.click_tag = true;

        var self = this;
        setTimeout(() => {
          self.click_tag = false;
        }, 5000);

        //this.$router.push({ name: "vip_center" });
        var uid = this.$store.state.uid;
        var type = "兑换金币";
        this.post({
          url: "/App/Tx_Coin",
          data: { type: type, score: data.score, coin: data.coin, uid: uid },
          success: function (serve_data) {
            //console.log(JSON.stringify(serve_data));
            if (serve_data.state == "1") {
              self.$toast.center("兑换成功");
              self.act_reload_userinfo({
                uid: uid,
                success: function (info) {
                  self.init_page();

                  //self.formshow_txAft();
                },
              });
            }else{
              alert(serve_data.msg);
            }
          },
        });
      }
    },

    //积分兑换会员
    barter_vip(days, score) {
      if(this.is_kill!=0){
         this.$toast.center("该账号已被封禁，无法使用积分兑换功能");
          return false;
      }
      if (score == 8800 && this.score_tx < score) {
        this.$toast.center("你的可用积分不足以兑换1天会员");
        return false;
      }
      if (score == 29900 && this.score_tx < score) {
        this.$toast.center("你的可用积分不足以兑换7天会员");
        return false;
      }

      var ctxt ="兑换" + days +"天会员，需要消耗" +score +"积分，点击下方兑换按钮则可兑换成功，无需客服审核，立马获得会员";

      this.$refs.formshow_tx_vip.show(ctxt, {
        type: "confirm",
        confirmText: "立即兑换",
        titleText: "兑换会员",
        data: { days: days, score: score },
      });
    },

    formact_collect_vip(type, data) {
      if (type == "clickConfirm") {
        //处理连续点击问题
        if (this.click_tag) return;
        this.click_tag = true;

        var self = this;
        setTimeout(() => {
          self.click_tag = false;
        }, 5000);

        var uid = this.$store.state.uid;
        var type = "VIP";
        this.post({
          url: "/App/Tx_VIP",
          data: {uid: uid, vip_type: type, days: data.days, score: data.score},
          success: function (serve_data) {
            //console.log(JSON.stringify(serve_data));
            if (serve_data.state == "1") {
              self.$toast.center("兑换成功");
              self.act_reload_userinfo({
                uid: uid,
                success: function (info) {
                  self.init_page();
                },
              });
            }else{
              alert(serve_data.msg);
            }
          },
        });
      }
    },

    //关注公众号提示
      show_sys_GuanzhuWx() {
        var qrcode_url = require('../../assets/img/qrcode_xhc.jpg');
        var gzh_name = '小火柴';
        var code_link='https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzI1NzM4MTAzOQ==#wechat_redirect';
         //加载dic信息
         var sysdic = this.$store.state.sysdic;
        if(sysdic){
            qrcode_url = sysdic.wx_gzh_qrcode;
            gzh_name = sysdic.wx_gzh_name;
        }

        var h = '<div style="line-height:1.6em;font-size:.85em;"><label style=" font-weight: bold;font-size:1.1em;">当前版本过低，<label style=" font-weight: bold;font-size:1.1em;color:red;">"提现"</label>功能无法使用</label>，请关注公众号【<a style="color: rgb(186, 97, 255)" href='+code_link+'>'+ gzh_name +'<a/>】，开启提现功能~<div>'
             + '<div class="ub ub-ac ub-pc dlg-img"><img src="' + qrcode_url + '"  style="margin: 1rem 0"/></div>'
             + '<div style="line-height:1.6em; text-align:center;">长按开启提现功能<div>'
        this.$refs.myForm_2.show(h, {
          type: 'alert',
          confirmText: '长按上方二维码',
          titleText: '温馨提示',
          data: ''
        });
      },
  },
};
</script>

<style lang="scss" scoped>
.nav-top {
  background-color: #8A61FF;
}

.top {
  padding: 1.1rem 1.5rem 2rem 1.5rem;
  background-color: #8A61FF;
  background-image: linear-gradient(to bottom, #8A61FF 13%, #FE9CC0 91%);
  div {
    width: 50%;
  }
  .score {
    font-size: 1.8rem;
    font-weight: 600;
    color: #fff;
  }
  .txt {
    color: #fff;
    margin-top: 0.3rem;
  }
  .frost {
    font-size: 1.8rem;
    color: #dfdfdf;
  }
  .wt-img {
    width: 1.2rem;
    width: 1.2rem;
    margin: 0.3rem 0 0 0.3rem;
  }
}

.tx-block {
  padding: 0.8rem;
  .tx {
    margin-bottom: 0.8rem;
    .tx-item {
      width: 41%;
      padding: 0.8rem;
      background-color: #fff;
      border-radius: 0.5rem;
      div {
        font-size: 2.1rem;
        font-weight: 600;
        width: 100%;
        color: #fff;
        line-height: 5.5rem;
        background-size: 100% 100%;
        background-image: url(../../assets/img/提现背景图.png);
        span {
          font-size: 1.8rem;
          font-weight: 400;
        }
      }
      .score2 {
        color: #999;
        font-size: 1.1rem;
        margin-top: 1rem;
      }
      .dtl {
        font-size: 0.9rem;
        margin-top: 0.5rem;
        color: #999;
      }
    }
    .no {
      background-color: #dcdcdc;
      div {
        color: #666;
        background-image: url(../../assets/img/提现背景图2.png);
      }
    }
    .tx-item-coin {
      width: 41%;
      padding: 0.8rem;
      background-color: #fff;
      border-radius: 0.3rem;
      div {
        width: 100%;
        color: #fff;
        img {
          width: 80%;
        }
      }
      .sp1 {
        color: #fdcf00;
        font-size: 0.98rem;
      }
      .sp2 {
        font-size: 1.1rem;
        margin-top: 1rem;
        color: #999;
      }
    }
    .tx-item-vip {
      width: 41%;
      padding: 0.8rem;
      background-color: #fff;
      border-radius: 0.3rem;
      width: 41%;
      padding: 0.8rem;
      background-color: #fff;
      border-radius: 0.3rem;
      div {
        width: 100%;
        color: #fff;
        img {
          margin-top: 1rem;
          width: 80%;
        }
      }
      .sp1 {
        color: #fdcf00;
        font-size: 0.98rem;
      }
      .sp2 {
        font-size: 1.1rem;
        margin-top: 1rem;
        color: #999;
      }
      .vip-tag{
        margin-top: 2rem;
        color: #fd0101;
        font-size: 2rem;
      }
    }
  }
}

.tip-txt {
  padding: 0 0.8rem;
  .prompt-block {
    padding: 0.5rem 0.8rem;
    margin-bottom: 1rem;
    border-radius: 0.5rem;
    background-color: #fff;
    .prompt-img {
      width: 0.7rem;
      height: 0.7rem;
      margin: 0.3rem 0.3rem 0 0;
    }
    .prompt-txt {
      font-size: 0.75rem;
      line-height: 1.5rem;
      margin-bottom: 0.5rem;
      color: #666;
    }
  }
}

.container-dark {
  min-height: 100vh;
  background-color: #2F2E33;
  .tx-block {
    .tx {
      .tx-item-coin {
        background-color: #2c2b30;
      }
      .tx-item-vip {
        background-color: #2c2b30;
      }
      .tx-item {
        background-color: #2c2b30;
      }
    }
    
  }
  .tip-txt {
    .prompt-block {
      background-color: #2c2b30;
      .prompt-txt {
        color: #FDFDFD;
      }
    }
  }
}
</style>
